import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import ContentView from "./component";
import {
  getFlyers,
  setSelectedFlyerId,
  getFlyerItems,
  clearFlyerItems,
  setSelectedPublicationId
} from "../../actions";
import {
  selectedFlyer,
  selectedPublication,
  currentPublications
} from "../../selectors";
import { Flyer, FlyerItem } from "../../../core/Chart/Heatmap/types";
import { AnalyticsGlobalFilters } from "../../../Analytics/constants";

export interface ContentViewProps {
  metric: string;
  startDate: string;
  endDate: string;
  publications: any[];
  selectedPublication: any;
  flyers: Flyer[];
  selectedFlyer: Flyer;
  flyerItems: FlyerItem[];
  view: string;
  groupBy: string;
  flyerItemsLoading: boolean;
  flyersLoading: boolean;
  globalFilters: AnalyticsGlobalFilters;
  store: any;
}

export interface ContentViewActions {
  getFlyers: (flyerRunIds: number[], setDefault: boolean) => void;
  setSelectedFlyerId: (id: number) => void;
  getFlyerItems: (
    flyerId: number,
    metrics: string[],
    startDate: string,
    endDate: string,
    groupBy: string
  ) => void;
  clearFlyerItems: () => void;
  setSelectedPublicationId: (publicationId: number) => void;
}

const mapStateToProps = (state: any, props: any): ContentViewProps => {
  return {
    metric: state.analytics.metrics_container_tab,
    startDate: state.analytics.start_date,
    endDate: state.analytics.end_date,
    flyers: state.analytics_metric.flyers,
    flyerItems: state.analytics_metric.flyerItems,
    publications: currentPublications(state, props),
    selectedPublication: selectedPublication(state, props),
    selectedFlyer: selectedFlyer(state, props),
    view: state.analytics_metric.view,
    groupBy: state.analytics_metric.group_by,
    flyerItemsLoading: state.analytics_metric.flyer_items_loading,
    flyersLoading: state.analytics_metric.flyersLoading,
    globalFilters: state.analytics.globalFilters,
    store: state
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ContentViewActions => {
  return {
    ...Redux.bindActionCreators(
      {
        getFlyers,
        setSelectedFlyerId,
        getFlyerItems,
        clearFlyerItems,
        setSelectedPublicationId
      },
      dispatch
    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContentView)
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/ContentView/container.ts